import { DailyBookingSummaryDto } from 'Api/Features/Bookings/Dtos/DailyBookingSummaryDto';
import { DailyBookingSummaryAmenityDto } from 'Api/Features/Bookings/Dtos/DailyBookingSummaryAmenityDto';

export class DailyBookingSummary implements DailyBookingSummaryDto {
    constructor(dto: DailyBookingSummaryDto) {
        Object.assign(this, dto);
    }
    amenities: Array<DailyBookingSummaryAmenityDto | null> | null = null;
    hasAvailabilities = false;
}